<closeable-dialog class="defibrillator-info-dialog-container">
  <div class="dialog-header title" dialog-card-header>
    <label>{{errorHeader | translate}}  {{'healthErrorDescription' | translate}} &nbsp;</label>
  </div>
  <div dialog-card-body class="dialog-body full-height">
    <img src={{image}} width="300" height="300">
  </div>
</closeable-dialog>
